import { Suspense } from "react";
import { Label, LabelOutlined } from "@mui/icons-material";
import { Chip, Skeleton, Stack, StackProps, Typography } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";

import { useTags } from "hooks/indicatorHooks";

import { LayerProperties } from "types";

import { TagsLayerCount } from "./TagsLayerCount";

interface Props extends StackProps {
  config: string;
  search: string;
  selected: string[];
  setSelected: (tags: string[]) => void;
  layerProperties: LayerProperties[];
}

export function LayerTags(props: Props) {
  const {
    config,
    search,
    selected,
    setSelected,
    layerProperties,
    ...stackProps
  } = props;
  const { t } = useTranslation();
  const { data: tags } = useTags(config);

  function onClick(tag: string) {
    const currentIndex = selected.indexOf(tag);
    if (currentIndex === -1) {
      setSelected([...selected, tag]);
    } else {
      setSelected(selected.filter((currentTag) => currentTag !== tag));
    }
  }

  return (
    <Stack direction="row" spacing={1} {...stackProps} flexWrap="wrap">
      {tags &&
        tags.map((tag, i) => (
          <Chip
            icon={selected.indexOf(tag) > -1 ? <Label /> : <LabelOutlined />}
            key={`${tag}-${i}`}
            label={tag}
            variant="filled"
            onClick={() => onClick(tag)}
            color={selected.indexOf(tag) > -1 ? "primary" : undefined}
          />
        ))}
      <ErrorBoundary
        fallbackRender={(props) => (
          <Typography
            variant="body1"
            marginLeft="auto!important"
            paddingTop={1}
          >
            {t("label.numCards", { count: 0 })}
          </Typography>
        )}
      >
        <Suspense fallback={<Skeleton variant="text" />}>
          <TagsLayerCount
            config={config}
            selected={selected}
            search={search}
            layerProperties={layerProperties}
          />
        </Suspense>
      </ErrorBoundary>
    </Stack>
  );
}
